var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSadPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 322.956,
    height: 221,
    viewBox: "0 0 322.956 221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .a,.b{fill:#bce0fd;}.a,.c,.e{clip-rule:evenodd;}.c,.d{fill:none;}.e,.f{fill:#ff007c;}.g{clip-path:url(#a);}.h{clip-path:url(#b);}.i{clip-path:url(#c);}.j{clip-path:url(#e);}.k{clip-path:url(#g);}.l{clip-path:url(#i);}.m{clip-path:url(#k);}.n{clip-path:url(#m);}.o{clip-path:url(#o);}.p{clip-path:url(#q);}.q{clip-path:url(#s);}.r{clip-path:url(#u);}.s{clip-path:url(#w);}.t{clip-path:url(#y);}.u{clip-path:url(#aa);}.v{clip-path:url(#ac);}.w{clip-path:url(#ae);}.x{clip-path:url(#ag);}.y{clip-path:url(#ai);}.z{clip-path:url(#ak);}.aa{clip-path:url(#am);}.ab{clip-path:url(#an);}.ac{fill:#121413;}.ad{clip-path:url(#ao);}.ae{clip-path:url(#aq);}.af{clip-path:url(#as);}.ag{clip-path:url(#au);}.ah{clip-path:url(#aw);}.ai{clip-path:url(#ay);}.aj{clip-path:url(#ba);}.ak{clip-path:url(#bc);}.al{clip-path:url(#be);}.am{fill:#2e3230;}.am,.an{stroke:#798f9d;}.an{fill:#fff;}.ao{clip-path:url(#bg);}.ap{fill:#315164;}.aq{clip-path:url(#bi);}.ar{clip-path:url(#bk);}.as{clip-path:url(#bm);}.at{clip-path:url(#bo);}.au{fill:#e98ea2;}.av{clip-path:url(#bq);}.aw{fill:#e57a94;}.ax{clip-path:url(#bs);}.ay{clip-path:url(#bu);}.az{fill:#efb6be;}.ba{clip-path:url(#bw);}.bb{clip-path:url(#by);}.bc{clip-path:url(#bz);}.bd{clip-path:url(#ca);}.be{stroke:none;}\n        "), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M265.935-32.107c-20.07,0-32.865-14.955-51.956-22.578a104.812,104.812,0,0,0-37.615-6.847A115.092,115.092,0,0,0,127.6-50.568c-17.149,7.707-41.335,14.713-63.879,14.713C36.6-35.855,11.859-46,4.64-77.274-.3-98.526,6.965-113.417,26.48-121.351c7.47-2.91,15.205-7.3,19.425-14.781,5.823-9.995-1.072-25.116-2.37-35.822-3.524-30.578,13.575-38.662,36.983-38.662,13.131,0,28.248,2.545,42.821,5.089s28.6,5.089,39.561,5.088a39.719,39.719,0,0,0,11.866-1.493l-1.761.121c8.1-2.354,12.277-10.437,19.708-13.944a30.369,30.369,0,0,1,12.115-2.666c22.339,0,36.6,28.133,57.148,33.906,10.8,2.859,20.7.982,31.613,5.631,13.343,5.684,20.239,20.8,20.052,35.809-.852,13.854-11.924,22.814-18.215,34.64-7.465,11.907-4.762,17.119-1,29.454,6.624,19.938,3.2,41.357-19.485,45.909a43.866,43.866,0,0,1-9.009.964",
    transform: "translate(-3.14 218.421)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-65,115.716H362.716V-312H-65Z",
    transform: "translate(65 312)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M189.2-205.951c-3.034,0-3.034-4.7,0-4.7s3.034,4.7,0,4.7",
    transform: "translate(-186.92 210.656)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.874-122.183c-6.068,0-6.068-9.41,0-9.41s6.068,9.41,0,9.41",
    transform: "translate(-21.322 131.593)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M356.561-78.321c-6.068,0-6.068-9.41,0-9.41s6.068,9.41,0,9.41",
    transform: "translate(-352.009 87.731)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M170.249-209.5c-6.068,0-6.068-9.41,0-9.41s6.068,9.41,0,9.41",
    transform: "translate(-165.697 218.906)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M367.33-96.26c-7.889,0-7.889-12.233,0-12.233s7.889,12.233,0,12.233",
    transform: "translate(-361.413 108.493)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.081-104.51c-7.889,0-7.889-12.233,0-12.233s7.888,12.233,0,12.233",
    transform: "translate(-1.165 116.743)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M312.33-190.448c-7.889,0-7.889-12.233,0-12.233s7.889,12.233,0,12.233",
    transform: "translate(-306.413 202.681)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M185.676-219.228c-9.1,0-9.1-14.115,0-14.115s9.1,14.115,0,14.115",
    transform: "translate(-178.85 233.343)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M373.666-82.462c-4.551,0-4.551-7.057,0-7.057s4.551,7.057,0,7.057",
    transform: "translate(-370.253 89.519)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.578-126.6c-4.551,0-4.551-7.057,0-7.057s4.552,7.057,0,7.057",
    transform: "translate(-2.165 133.656)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M329.941-181.6c-4.552,0-4.552-7.057,0-7.057s4.551,7.057,0,7.057",
    transform: "translate(-326.527 188.656)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M328.758-196.326c-3.034,0-3.034-4.7,0-4.7s3.033,4.7,0,4.7",
    transform: "translate(-326.483 201.031)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M49.8-206.609c-6.068,0-6.068-9.41,0-9.41s6.068,9.41,0,9.41",
    transform: "translate(-45.248 216.019)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M362.749-17c-6.068,0-6.068-9.41,0-9.41s6.068,9.41,0,9.41",
    transform: "translate(-358.198 26.405)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.249-12.183c-6.068,0-6.068-9.41,0-9.41s6.068,9.41,0,9.41",
    transform: "translate(-0.698 21.593)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ag"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M66.683-214.064c-3.034,0-3.034-4.7,0-4.7s3.034,4.7,0,4.7",
    transform: "translate(-64.408 218.769)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ai"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M363.82-38.2c-3.034,0-3.034-4.7,0-4.7s3.034,4.7,0,4.7",
    transform: "translate(-361.545 42.905)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ak"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.133-4.513c-3.034,0-3.034-4.7,0-4.7s3.033,4.7,0,4.7",
    transform: "translate(-19.858 9.218)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "am"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M90.128-105.226c-2.886,1.019-4.791,1.214-6.27-1.7-1.138-2.247-1.9-4.568-3.33-6.671-3.106-4.559-6.115-4.865-11.087-4.216-4.936.645-11.67-.616-12.419-6.324-.534-4.069-.565-7.809-2.347-11.615-.877-1.875-3.646-.243-2.773,1.622,1.976,4.223,1.111,8.821,2.558,13.122,1.467,4.365,6.354,5.772,10.46,6.262,3.1.37,5.821-.379,8.864-.375,3.268,0,5.5,5.609,6.535,8.07,2.158,5.13,5.217,6.851,10.663,4.928,1.94-.685,1.1-3.789-.854-3.1",
    transform: "translate(-51.734 136.588)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "an"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-65,77.411H324.41V-312H-65Z",
    transform: "translate(65 312)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ao"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M56.249-141.27a9.6,9.6,0,0,1-3.537,2.752c-1.48.745-.178,2.963,1.3,2.219a12.345,12.345,0,0,0,4.46-3.673,1.287,1.287,0,0,0-.461-1.759,1.316,1.316,0,0,0-1.759.461",
    transform: "translate(-52.06 141.908)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aq"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M51.531-145.834c.007,2.717.4,5.421.428,8.139a1.285,1.285,0,0,0,2.569,0c-.024-2.718-.421-5.421-.428-8.139a1.286,1.286,0,0,0-2.57,0",
    transform: "translate(-51.531 147.077)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "as"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M45.878-142.756a24.255,24.255,0,0,0,5.828,5.769c1.41.881,2.7-1.343,1.3-2.219a22.544,22.544,0,0,1-5.308-5.367c-1.035-1.294-2.841.537-1.817,1.817",
    transform: "translate(-45.573 145.015)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "au"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M43.1-137.784a8.358,8.358,0,0,0,8.532,2.044c1.58-.483.907-2.964-.683-2.479a5.752,5.752,0,0,1-6.032-1.382c-1.2-1.138-3.023.677-1.817,1.817",
    transform: "translate(-42.705 139.961)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aw"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M268.83-95.159c.116-4.2,1.519-5.6,5.572-5.929a77.33,77.33,0,0,0,7.909-.664c3.974-.74,3.9-6.223,5.439-9.052,2.349-4.322,8.659-3.862,12.731-5.139,4.487-1.406,6.209-5.2,6.473-9.628.125-2.071-3.089-2.058-3.213,0-.393,6.581-5.22,6.81-10.521,7.9a11.859,11.859,0,0,0-9.463,8.026c-.509,1.41-.632,4.348-2.3,4.8-2.717.728-5.844.4-8.639.7-5.252.569-7.062,4.007-7.2,8.992-.057,2.073,3.156,2.068,3.213,0",
    transform: "translate(-265.617 127.119)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ay"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M308.969-130.656a10.159,10.159,0,0,0,5.61,5.61,1.286,1.286,0,0,0,1.581-.9,1.318,1.318,0,0,0-.9-1.581,7.252,7.252,0,0,1-3.815-3.814,1.317,1.317,0,0,0-1.58-.9,1.287,1.287,0,0,0-.9,1.581",
    transform: "translate(-308.899 132.286)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M313.88-134.834v6.425a1.286,1.286,0,0,0,2.571,0v-6.425a1.286,1.286,0,0,0-2.571,0",
    transform: "translate(-313.88 136.077)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bc"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M318.192-134.071a11.862,11.862,0,0,1-3.953,5.43c-1.284,1.048.545,2.855,1.818,1.817a14.26,14.26,0,0,0,4.614-6.564c.544-1.57-1.939-2.238-2.478-.683",
    transform: "translate(-313.801 134.955)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "be"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M321.85-130.535a9.868,9.868,0,0,1-4.8,3.693c-1.512.62-.851,3.107.683,2.479a12.844,12.844,0,0,0,6.337-4.875c.886-1.406-1.338-2.695-2.22-1.3",
    transform: "translate(-316.195 131.137)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M158.777-126.918l-9.693,9.692a1.285,1.285,0,0,0,0,1.818,1.285,1.285,0,0,0,1.817,0l9.693-9.692a1.285,1.285,0,0,0,0-1.818,1.286,1.286,0,0,0-1.818,0",
    transform: "translate(-148.707 127.294)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bi"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M160.594-117.224l-9.692-9.693a1.285,1.285,0,0,0-1.817,0,1.285,1.285,0,0,0,0,1.818l9.692,9.692a1.285,1.285,0,0,0,1.817,0,1.284,1.284,0,0,0,0-1.817",
    transform: "translate(-148.708 127.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bk"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M214.877-126.918l-9.694,9.692a1.286,1.286,0,0,0,0,1.818,1.286,1.286,0,0,0,1.818,0l9.693-9.692a1.286,1.286,0,0,0,0-1.818,1.285,1.285,0,0,0-1.817,0",
    transform: "translate(-204.807 127.294)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bm"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M216.695-117.224,207-126.917a1.286,1.286,0,0,0-1.818,0,1.286,1.286,0,0,0,0,1.818l9.692,9.692a1.285,1.285,0,0,0,1.817,0,1.285,1.285,0,0,0,0-1.817",
    transform: "translate(-204.809 127.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M210.846-98.181v9.566a3.426,3.426,0,0,1-3.427,3.427h-1.848a3.426,3.426,0,0,1-3.427-3.427v-9.566",
    transform: "translate(-202.144 98.181)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bq"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M208.807-97.54,207.3-86.4,205.8-97.54h3.005",
    transform: "translate(-205.801 97.54)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bs"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M147.033-97.428h58.09a1.071,1.071,0,0,0,1.071-1.071,1.071,1.071,0,0,0-1.071-1.071h-58.09a1.071,1.071,0,0,0-1.071,1.071,1.071,1.071,0,0,0,1.071,1.071",
    transform: "translate(-145.962 99.57)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bu"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M133.954-102.447c5.525,0,5.525-8.567,0-8.567s-5.525,8.567,0,8.567",
    transform: "translate(-129.81 111.014)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bw"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M232.954-102.447c5.525,0,5.525-8.567,0-8.567s-5.525,8.567,0,8.567",
    transform: "translate(-228.81 111.014)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "by"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M243.48-187.035v32.151c0,3.142,4.872,3.142,4.872,0v-32.151c0-3.142-4.872-3.142-4.872,0",
    transform: "translate(-243.48 189.391)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bz"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-65,130.857H377.866V-312H-65Z",
    transform: "translate(65 312)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ca"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M245.774-137.349c4.713,0,4.713-7.307,0-7.307s-4.712,7.307,0,7.307",
    transform: "translate(-242.24 144.656)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26 -346)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.303 374.343)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "translate(2.787 -15.578)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(-58.289 -80.051)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-1.86-223.421H317.2V-28.553H-1.86Z",
    transform: "translate(55.872 299.194)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(159.998 -8.936)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(-215.5 -86.693)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M181.92-215.656h13.106V-202.4H181.92Z",
    transform: "translate(29.303 298.072)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "translate(18.341 58.697)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(-73.843 -154.326)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16.322-136.593H33.979v17.964H16.322Z",
    transform: "translate(53.243 286.642)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "translate(301.221 96.218)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(-356.724 -191.847)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M347.01-92.731h17.657v17.964H347.01Z",
    transform: "translate(5.437 280.301)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "l",
    transform: "translate(141.844 -15.993)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(-197.346 -79.636)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M160.7-223.906h17.656v17.964H160.7Z",
    transform: "translate(32.372 299.264)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "m",
    transform: "translate(309.266 78.458)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(-364.768 -174.087)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M356.414-113.493H376.8v20.787H356.414Z",
    transform: "translate(4.077 283.302)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "n",
    transform: "translate(1.097 71.4)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(-56.599 -167.029)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-3.835-121.743H16.551v20.787H-3.835Z",
    transform: "translate(56.158 284.495)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "o",
    transform: "translate(262.217 -2.114)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(-317.719 -93.515)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M301.414-207.681H321.8v20.787H301.414Z",
    transform: "translate(12.029 296.919)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "p",
    transform: "translate(153.095 -28.343)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(-208.597 -67.286)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M173.85-238.343h22.208v22.669H173.85Z",
    transform: "translate(30.47 301.352)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "q",
    transform: "translate(316.827 94.689)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(-372.33 -190.318)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M365.253-94.519h15.381v15.612H365.253Z",
    transform: "translate(2.799 280.559)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "r",
    transform: "translate(1.953 56.933)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(-57.455 -152.561)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-2.835-138.656H12.546v15.612H-2.835Z",
    transform: "translate(56.013 286.94)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "s",
    transform: "translate(279.423 9.884)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(-334.925 -105.512)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M321.527-193.656h15.381v15.612H321.527Z",
    transform: "translate(9.121 294.891)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "t",
    transform: "translate(279.385 -0.702)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(-334.887 -94.926)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M321.483-206.031h13.1v13.259h-13.1Z",
    transform: "translate(9.127 296.68)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(38.808 -13.523)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(-94.31 -82.105)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M40.248-221.019H57.9v17.964H40.248Z",
    transform: "translate(49.785 298.847)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "v",
    transform: "translate(306.515 148.679)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(-362.017 -244.307)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M353.2-31.4h17.656v17.964H353.2Z",
    transform: "translate(4.542 271.435)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(0.698 152.795)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(-56.2 -248.424)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-4.3-26.593H13.354V-8.629H-4.3Z",
    transform: "translate(56.225 270.739)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "x",
    transform: "translate(55.197 -15.876)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(-110.7 -79.753)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M59.408-223.769H72.513v13.259H59.408Z",
    transform: "translate(47.015 299.245)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "y",
    transform: "translate(309.378 134.564)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(-364.88 -230.193)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M356.545-47.905H369.65v13.259H356.545Z",
    transform: "translate(4.058 273.82)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "z",
    transform: "translate(17.088 163.381)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(-72.59 -259.01)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.858-14.218H27.963V-.959H14.858Z",
    transform: "translate(53.455 268.95)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "aa",
    transform: "translate(96.966 437.572)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ab",
    transform: "translate(-90.915 -136.615)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M46.734-141.588H94.872v43.013H46.734Z",
    transform: "translate(40.287 274.309)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ad",
    transform: "translate(97.221 433.43)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ab",
    transform: "translate(-91.169 -132.472)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M47.06-146.908h14.39v13.547H47.06Z",
    transform: "translate(40.215 275.485)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ae",
    transform: "translate(96.808 429.404)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ab",
    transform: "translate(-90.757 -128.446)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M46.531-152.077H57.317v18.413H46.531Z",
    transform: "translate(40.332 276.629)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "af",
    transform: "translate(92.169 431.009)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ab",
    transform: "translate(-86.117 -130.051)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M40.573-150.015H56.4V-134H40.573Z",
    transform: "translate(41.649 276.173)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ag",
    transform: "translate(89.935 434.945)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ab",
    transform: "translate(-83.883 -133.987)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M37.705-144.962H55.322v12.423H37.705Z",
    transform: "translate(42.284 275.055)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ah",
    transform: "translate(238.051 444.947)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ab",
    transform: "translate(-257.491 -143.989)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M260.617-132.119h49.128v41.3H260.617Z",
    transform: "translate(-7.02 272.214)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ai",
    transform: "translate(271.76 440.923)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ab",
    transform: "translate(-291.2 -139.965)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M303.9-137.286H319v15.1H303.9Z",
    transform: "translate(-16.593 273.357)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "aj",
    transform: "translate(275.64 437.971)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ab",
    transform: "translate(-295.08 -137.013)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M308.88-141.077h10.359v16.7H308.88Z",
    transform: "translate(-17.695 274.196)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ak",
    transform: "translate(275.578 438.845)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ab",
    transform: "translate(-295.018 -137.887)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M308.8-139.955h14.735v16.23H308.8Z",
    transform: "translate(-17.677 273.947)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "al",
    transform: "translate(277.442 441.818)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ab",
    transform: "translate(-296.882 -140.86)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M311.195-136.137h15.868v14.663H311.195Z",
    transform: "translate(-18.206 273.103)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "am",
    transform: "translate(135 388)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "be",
    width: 107,
    height: 179,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 106,
    height: 178,
    rx: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "an",
    transform: "translate(140 395)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "be",
    width: 96,
    height: 148,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 95,
    height: 147,
    rx: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "ao",
    transform: "translate(159.745 444.811)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ab",
    transform: "translate(-166.44 -143.853)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M143.707-132.294h20.052v20.05H143.707Z",
    transform: "translate(18.838 272.253)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "aq",
    transform: "translate(159.746 444.812)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ab",
    transform: "translate(-166.44 -143.854)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M143.708-132.293h20.051v20.051H143.708Z",
    transform: "translate(18.838 272.253)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ar",
    transform: "translate(203.437 444.811)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ab",
    transform: "translate(-210.131 -143.853)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M199.807-132.294h20.052v20.05H199.807Z",
    transform: "translate(6.43 272.253)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "as",
    transform: "translate(203.438 444.812)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ab",
    transform: "translate(-210.133 -143.854)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M199.809-132.293h20.05v20.051h-20.05Z",
    transform: "translate(6.43 272.253)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "at",
    transform: "translate(201.363 467.485)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ab",
    transform: "translate(-208.057 -166.527)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M197.144-103.181h16.49V-82.4h-16.49Z",
    transform: "translate(7.019 265.814)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "av",
    transform: "translate(204.211 467.984)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ab",
    transform: "translate(-210.905 -167.026)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aw",
    d: "M200.8-102.54h10.794v18.925H200.8Z",
    transform: "translate(6.21 265.672)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ax",
    transform: "translate(157.608 466.403)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ab",
    transform: "translate(-164.302 -165.445)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M140.962-104.57h68.02v9.93h-68.02Z",
    transform: "translate(19.445 266.121)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ay",
    transform: "translate(145.028 457.49)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ab",
    transform: "translate(-151.722 -156.532)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "M124.811-116.014h16.076v16.355H124.811Z",
    transform: "translate(23.018 268.652)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ba",
    transform: "translate(222.132 457.49)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ab",
    transform: "translate(-228.826 -156.532)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "M223.811-116.014h16.076v16.355H223.811Z",
    transform: "translate(1.121 268.652)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "bb",
    transform: "translate(227.374 374.598)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bc",
    transform: "translate(-273.231 -108.596)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M238.48-194.391h13.729v45.721H238.48Z",
    transform: "translate(30.322 298.559)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "bd",
    transform: "translate(226.276 414.22)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bc",
    transform: "translate(-272.132 -148.219)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M237.24-149.656h15.926v16.164H237.24Z",
    transform: "translate(30.464 293.447)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "am",
    transform: "translate(182 548)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "be",
    cx: 7,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 7,
    cy: 7,
    r: 6.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadPhone);
export default __webpack_public_path__ + "static/media/sadPhone.641cee9675ea866aed671f23668abb0e.svg";
export { ForwardRef as ReactComponent };